export const DEFAULT_INPUT_BORDER = 'border-gray-300';
export const DEFAULT_INPUT_PLACEHOLDER = 'text-gray-400';
export const DEFAULT_INPUT_COLOR = 'text-gray-900';
